<div class="dialog-container">
  <div *ngIf="!showExtractedTexts">
    <h2 class="card-header header-background style-header">Below tiers have been selected to build your panel.
      Please confirm to continue designing.</h2>
    <table class="selected-items-table">
      <tr>
        <th>PreBuildTierName</th>
        <th>Width</th>
        <th>Height</th>
      </tr>
      <tr *ngFor="let selectedItemWithDetails of selectedItemsWithDetails; let i = index"
        [class.highlighted]="i < selectedItems.length">
        <td>{{ selectedItemWithDetails.preBuildTierName }}</td>
        <td>{{ selectedItemWithDetails.width }}</td>
        <td>{{ selectedItemWithDetails.height }}</td>
      </tr>
      <!-- <tr *ngFor="let selectedItemWithDetails of selectedItemsWithDetails; let i = index"
        [class.highlighted]="i < selectedItems.length"
        (click)="handleRowClick(i, selectedItemWithDetails.preBuildTierName)"
        >
        <td>{{ selectedItemWithDetails.preBuildTierName }}</td>
        <td>{{ selectedItemWithDetails.width }}</td>
        <td>{{ selectedItemWithDetails.height }}</td>
      </tr> -->
    </table>
  </div>
  <div *ngIf="showExtractedTexts" class="extracted-texts">
    <h2 class="card-header header-background style-header">Below tiers have been selected to build your panel.
      Please confirm to continue designing.</h2>
    <div class="title-header">{{ selectedPreBuildTierName }}'s Items</div>
    <div *ngFor="let text of matchingNodeTextArray" class="text-style">{{ text }}</div>
    <div class="buttons get-center">
      <button mat-button (click)="showExtractedTexts = false">
        <mat-icon>arrow_back</mat-icon>Back</button>
    </div>
  </div>
  <div class="buttons" *ngIf="!showExtractedTexts">
    <button mat-button (click)="ok()">Confirm</button>
    <button mat-button (click)="cancel()">Cancel</button>
  </div>
</div>